import styled from "styled-components";
import { FlexContainer,SecondaryButton,PrimaryButton } from "./styled";
import ProgressBar from "./shared/progressBar";
import { useUserContext } from "../context/UserContext";

const ChangeDungeonConfirmModalContent = ({onClose,changeDungeon}) => {
    const {user} = useUserContext();

    return(
        <ContentContainer>
          <h3 style={{
            textAlign: "center",
            position:"absolute",
            top:"-36px",
            padding:"0 32px",
          }}>Do you really want to change dungeon?</h3> 
            <ProgressBarContainer>
                <span>Your Energy level</span>
                <FlexContainer>
                <ProgressBar progress={user.energy} />
                <span>{user.energy.toFixed(2)}</span>
                </FlexContainer>
            </ProgressBarContainer>
            <FlexContainer>
                <PrimaryButton style={{maxWidth:"120px"}} onClick={onClose}>Cancel</PrimaryButton>
                <StyledPrimaryButton onClick={changeDungeon}>Confirm</StyledPrimaryButton>
            </FlexContainer>
        </ContentContainer>
    )
};
const ContentContainer = styled(FlexContainer)`
    flex-direction: column;
    gap: 0;
    padding: 16px 22px;
    align-items: center;
    overflow-y: auto;
    padding-bottom: 24px;
`;

const ProgressBarContainer = styled(FlexContainer)`
    width: 100%;
    gap: 16px;
    min-height:68px;
    background: #D9D9D917;
    box-shadow: 0px 4px 22.4px 0px #00000040;
    padding:16px 64px; 
    margin: 16px 0;
    border-radius: 10px;
    flex-direction: column;  
`
const StyledPrimaryButton = styled(PrimaryButton)`
    background: linear-gradient(180deg, #9939AD 12.44%, #40297C 45.28%, #250964 50.97%, #582063 100%);
    backdrop-filter: blur(10.800000190734863px);
    box-shadow: 0px 7px 0px 0px #471964;
    max-width: 120px;
    `
export default ChangeDungeonConfirmModalContent;